import { useEffect, useState } from 'react';
import {
  subscribeWorldTransactionNotice,
  type WorldTransactionNotice,
} from '../lib/worldMiniKit';

export default function WorldTransactionToast() {
  const [notice, setNotice] = useState<WorldTransactionNotice | null>(null);

  useEffect(() => subscribeWorldTransactionNotice(setNotice), []);

  if (!notice) return null;

  return (
    <div className="world-transaction-toast" role="status" aria-live="polite" aria-atomic="true">
      <span className="world-transaction-toast-icon" aria-hidden="true">i</span>
      <div>
        <strong>{notice.title}</strong>
        <p>{notice.description}</p>
      </div>
    </div>
  );
}
